define('fukit/view/block/unsaved.changes.modal.view',['require','exports','module','underscore','uikit/uikit','../../helpers/factory'],function(require, exports, module) {
  //prettier-ignore
  var _       = require('underscore'),
      UIKit   = require('uikit/uikit'),
      Factory = require('../../helpers/factory');

  var UnsavedChangesModalView = UIKit.Modal2.extend({
    options: _.extend({}, UIKit.Modal2.prototype.options, {
      basic: true,
      closeable: true,
      size: 'small',
    }),

    header: {
      text: 'Unsaved Changes',
    },

    content: {
      type: UIKit.Modal2.SimpleContentView,
      text: 'There are unsaved changes. Are you sure you want to lose them?',
      icon: 'file text outline',
    },

    actions: {
      components: [
        {
          type: UIKit.Modal2.DenyButtonView,
          text: "Don't Save",
          color: 'basic red',
          inverted: true,
          icon: 'remove',
        },
        Factory.saveButton({
          type: UIKit.Modal2.ConfirmButtonView,
          color: 'positive',
          behaviors: {},
        }),
      ],
    },
  });

  module.exports = UnsavedChangesModalView;
});

